export default __webpack_public_path__ + "assets/enterprise-two-one-small.b8e0e4a78a27157cffe8766ff78a46cf.png";